export const msalConfig = {
    authority: 'https://login.microsoftonline.com/e3b48527-4cbe-42a2-b4d2-11b3cc7a86fc',
    clientId: 'b64000a4-0ca8-49dd-ac3f-2bcabaae5625'
}